// Custom Grid component wrapper for Material-UI v7 compatibility
// Material-UI v7 Grid component has different API, so we create a wrapper
import React from 'react';
import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';

interface CustomGridProps extends Omit<MuiGridProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl'> {
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
  children?: React.ReactNode;
  sx?: any;
  alignItems?: string;
  size?: { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
}

const Grid: React.FC<CustomGridProps> = ({ xs, sm, md, lg, xl, children, size, ...props }) => {
  // For container grids, pass through all props
  if (props.container) {
    return <MuiGrid {...props}>{children}</MuiGrid>;
  }

  // For item grids, convert size props to sx
  const sizeProps: any = {};

  // Handle size prop (Material-UI v7 style)
  if (size) {
    if (size.xs !== undefined) sizeProps.xs = size.xs;
    if (size.sm !== undefined) sizeProps.sm = size.sm;
    if (size.md !== undefined) sizeProps.md = size.md;
    if (size.lg !== undefined) sizeProps.lg = size.lg;
    if (size.xl !== undefined) sizeProps.xl = size.xl;
  } else {
    // Handle individual size props (legacy style)
    if (xs !== undefined) sizeProps.xs = xs;
    if (sm !== undefined) sizeProps.sm = sm;
    if (md !== undefined) sizeProps.md = md;
    if (lg !== undefined) sizeProps.lg = lg;
    if (xl !== undefined) sizeProps.xl = xl;
  }

  return <MuiGrid item {...sizeProps} {...props}>{children}</MuiGrid>;
};

export default Grid;
